<span *ngIf="isInvalid"> Invalid Resource {{ resourceData?.Title }}</span>

<mat-card appearance="outlined" *ngIf="resourceData && isVisible" [class]="isInvlid() ? 'file-uploader-error file-uploader-card d-flex flex-column file-uploader-card mat-card' :
            'file-uploader-card d-flex flex-column file-uploader-card mat-card'"
  [class.disabled]="files.length === maxFilesLimit" (click)="openCamera()">
  <div class="file-uploader-btn-icon">
    <button role="button" title="file uploader" mat-icon-button type="button">
      <mat-icon>
        <!-- cloud_upload -->
        {{resourceData?.IconClass}}
      </mat-icon>
    </button>
  </div>
  <div class="font file-uploader-scan-with-camera">
    {{scanText}}
    <!-- Scan with Camera -->
  </div>
  <div class="font file-uploader-use-the-camera-app">
    {{scanSubText}}
    <!-- Use the camara app to scan a Front & Back copy of the
    customer's ID -->
  </div>
</mat-card>

<div class="file-uploader-container">
  <mat-form-field class="file-uploader-custom-form" appearance="outline">
    <input matInput [formControl]="control" />
  </mat-form-field>
  <input [style.display]="'none'" #file type="file" accept="image/*" (change)="change($event)" capture="environment" />
</div>
<div *ngIf="!!errorMessage" class="file-uploader-error-div">
  <Span [innerHTML]="errorMessage" class="error-text"></Span>
</div>
<div *ngIf="files.length > 0">
  <div class="file-uploader-uploaded-documents">{{resourceData?.PlaceHolder}}</div>
  <hr />
  <div class="row" *ngFor="let file of files">
    <div class="col-1 done">
      <mat-icon>
        done
      </mat-icon>
    </div>
    <div class="col-md uploaded-file">
      {{file.Name}}
    </div>
    <div class="col-1 text-right mat-padding">
      <button class="delete" role="button" title="Delete File" mat-icon-button (click)="deleteFileItem(file.Name)">
        <mat-icon>
          <!-- cloud_upload -->
          delete_outline
        </mat-icon>
      </button>
    </div>
  </div>
</div>
<mat-progress-bar *ngIf="bufferValue >0" [mode]="mode" [value]="bufferValue">
</mat-progress-bar>